<script setup>

import { ref, inject, watch } from 'vue';

import Listbox from 'primevue/listbox';
import Import from './Import.vue';
import ModaleAjoutImport from './ModaleAjoutImport.vue';

const { imports } = defineProps({
	imports: Array
});

const selectionSchema = inject('selectionSchema');
const evenement = inject('evenement');

const affichageModaleAjoutImport = ref(false);

function afficherModaleAjoutImport() {
	affichageModaleAjoutImport.value = true;
}

watch(() => evenement.value.nouveauModeleImport, (nouveauModeleImport) => {
	if (nouveauModeleImport) {
		delete evenement.value.nouveauModeleImport;
		afficherModaleAjoutImport();
	}
});

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Modèles d'import</label>
			<div class="conteneur-boutons">
				<button class="bouton fa-solid fa-plus" @click="afficherModaleAjoutImport()" />
			</div>
		</div>
		<Listbox class="liste-imports" 
		  v-model="selectionSchema.import" 
		  :options="imports"
		  :selectOnFocus="true"
		  :emptyMessage="'Aucun import'"
		  :optionLabel="'nom'"
		  :disabled="!imports.length">
			<template #option="slotProps">
				<Import :importDonnees="slotProps.option" :selectionne="slotProps.option == selectionSchema.import" />
			</template>
		</Listbox>
		<ModaleAjoutImport 
		  v-model:visible="affichageModaleAjoutImport" />
	</div>
</template>

<style scoped>

.liste-imports {
	height: 15vh !important;
	overflow: auto;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>